export default __webpack_public_path__ + "static/media/5888925dbc2fc2ef3a1860ad.4a418522.png";